import { Shield } from 'lucide-react'
import { NavLink } from 'react-router'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from 'tailwind-v4/components/avatar'
import { gravatarImage } from '@/utils/common'
import useUser from '@/hooks/useUser'

function Profile() {
  const user = useUser()
  if (!user) return null

  const initials =
    `${user.first?.charAt(0) ?? ''}${user.last?.charAt(0) ?? ''}`.toUpperCase()

  return (
    <div className="group flex items-center gap-2 rounded-full py-1 pr-1 pl-3 transition-colors duration-100 hover:bg-accent">
      <div className="flex flex-col items-end">
        <span className="text-sm font-medium leading-tight text-foreground">
          {user.first} {user.last}
        </span>
        {user.role === 0 ? (
          <NavLink
            to="admin"
            className="flex items-center gap-1 text-xs text-muted-foreground transition-colors duration-100 hover:text-foreground"
          >
            <Shield className="size-3.5" />
            <span>Admin</span>
          </NavLink>
        ) : (
          <span className="text-xs text-muted-foreground">{user.company}</span>
        )}
      </div>

      <Avatar>
        <AvatarImage
          src={gravatarImage(user.email, 'gallery')}
          alt={`${user.first} ${user.last}`}
        />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
    </div>
  )
}

export default Profile
